import {createSlice, type PayloadAction} from '@reduxjs/toolkit';

export interface RouterStateUrl {
  url: string;
  params: Record<string, string>;
  queryParams: Record<string, string>;
}

const initialState: RouterStateUrl = {
  url: '/',
  params: {},
  queryParams: {},
};

const routerSlice = createSlice({
  name: 'router',
  initialState,
  reducers: {
    setRoute: (state, action: PayloadAction<RouterStateUrl>) => ({
      ...state,
      ...action.payload,
    }),
  },
});

export const {setRoute} = routerSlice.actions;
export default routerSlice.reducer;
